import React from 'react';

const Regulations = props => {
  return (
    <p className="buy-checkout-side__text">
      Приобретая билет Вы соглашаетесь <br />
      <a href={props.link} target="_blank">
        c&nbsp;условиями обработки персональных данных
      </a>
    </p>
  );
};

export default Regulations;
